import { useEffect } from 'react';

/**
 * One-shot scroll reveal. Adds `.is-visible` to any element with `.gmre-reveal` once it enters the viewport.
 * Mount once at the page level (e.g., from HomePage).
 */
export default function useReveal(deps = []) {
  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    const scan = () => {
      document.querySelectorAll('.gmre-reveal:not(.is-visible)').forEach((el) => io.observe(el));
    };
    scan();
    // Watch the DOM for new reveal nodes inserted after async data loads
    const mo = new MutationObserver(() => scan());
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
